<template>
  <div class="modal-content">
    <div class="modal-header">
      <h5 class="modal-title">
        <div class="title" v-if="getModalData.id">Edit Question</div>
        <div class="title" v-if="!getModalData.id">Add Question</div>
      </h5>
      <button type="button" class="close" @click="$store.dispatch('closeModal', true)">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div class="modal-body">
      <form class="form" @submit.prevent="onSubmit">
        <div class="row">
          <div class="col-8">
            <div class="form-group">
              <label>Section</label>
              <v-select class="form-control" v-model="form.section_id" :options="selectSections" :reduce="section => section.id">
                <template #search="{attributes, events}">
                  <input class="vs__search"
                         :required="!form.section_id"
                         v-bind="attributes"
                         v-on="events"/>
                </template>
              </v-select>
            </div>
          </div>
          <div class="col-4">
            <div class="form-group">
              <label>Number</label>
              <input type="text" class="form-control" v-model="form.number" required placeholder="0.00"/>
            </div>
          </div>
        </div>
        <div class="form-group">
          <label>Text</label>
          <input type="text" class="form-control" v-model="form.text" required/>
        </div>
        <div class="row">
          <div class="col-4">
            <div>
              <div class="badge badge-high mb-2">High</div>
              <div class="form-group">
                <label>Answer</label>
                <textarea type="text" class="form-control" v-model="form.high.text" required/>
              </div>
              <div class="form-group">
                <label>Weight</label>
                <input type="number" class="form-control" v-model="form.high.weight" required/>
              </div>
            </div>
          </div>
          <div class="col-4">
            <div class="badge badge-medium mb-2">Medium</div>
            <div class="form-group">
              <label>Answer</label>
              <textarea type="text" class="form-control" v-model="form.medium.text" required/>
            </div>
            <div class="form-group">
              <label>Weight</label>
              <input type="number" class="form-control" v-model="form.medium.weight" required/>
            </div>
          </div>
          <div class="col-4">
            <div class="badge badge-low mb-2">Low</div>
            <div class="form-group">
              <label>Answer</label>
              <textarea type="text" class="form-control" v-model="form.low.text" required/>
            </div>
            <div class="form-group">
              <label>Weight</label>
              <input type="number" class="form-control" v-model="form.low.weight" required/>
            </div>
          </div>
        </div>
        <div class="form-group">
          <label>Help</label>
          <textarea type="text" class="form-control" v-model="form.help" required/>
        </div>
        <div class="form__btn">
          <b-button type="submit" variant="primary" class="mx-auto btn-image mt-4" v-if="getModalData.id">
            <img src="../../assets/img/btn-ok-icon.png"> <span>Save</span>
          </b-button>
          <b-button type="submit" variant="primary" class="mx-auto btn-image mt-4" v-else>
            <img src="../../assets/img/btn-ok-icon.png"> <span>Add</span>
          </b-button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
  import {mapGetters, mapActions} from 'vuex'

  export default {
    name: 'ModalQuestion',
    computed: {
      ...mapGetters([
        'getModalData',
        'getSections',
        'getSectionId',
      ]),
    },
    data() {
      return {
        editMode: false,
        selectSections: [],
        form: {
          section_id: '',
          text: '',
          number: '',
          help: '',
          high: {
            text: '',
            weight: '',
          },
          medium: {
            text: '',
            weight: '',
          },
          low: {
            text: '',
            weight: '',
          },
        },
      }
    },
    mounted() {


      if (this.getModalData.id) {
        console.log('Все равено', this.getModalData)
        this.editMode = true
        this.form = {
          section_id: parseInt(this.getModalData.section_id),
          text: this.getModalData.text,
          number: this.getModalData.number,
          help: this.getModalData.help,
        }
        for (let answer of this.getModalData.answers) {
          if (answer.color === 'high')
            this.form.high = answer
          if (answer.color === 'medium')
            this.form.medium = answer
          if (answer.color === 'low')
            this.form.low = answer
        }
      } else if (this.getSectionId) {
        this.editMode = false
        this.form.section_id = this.getSectionId
      }
      this.selectSections = this.getSections.map(function (item) {
        return {label: item.name, id: item.id}
      })
    },
    methods: {
      ...mapActions([
        'storeQuestion',
        'updateQuestion',
        'setToast',
      ]),
      onSubmit() {
        if (this.getModalData.id)
          this.updateQuestion([this.getModalData.id, this.form])
        else
          this.storeQuestion(this.form)
      },
    }
  }
</script>

<style scoped>

</style>